import loadjs from 'loadjs'

let loadedImages = []

export function loadImage(img) {
	if (!~loadedImages.indexOf(img)) {
		loadjs(`img!${img}`)
		loadedImages.push(img)
	}
}
